// Modules
import { api } from "services/api/service";

// Constants
import { API_CREATE_NEW_USER_ROLE_GROUP, API_NEW_USER_ROLES, API_NEW_GROUP_ROLES, API_GET_USER_REPORT } from "constants/api";

// Imported definitions
import type { ApiResponse, ApiNewUserRoleGroupResponse, ApiRoleResponse, ExportUserListResponse, ExportUserListPayload } from "services/api/types";

// API
export const getNewUserRoleGroup = async (): Promise<ApiResponse<ApiNewUserRoleGroupResponse>> => {
	return (await api()).get(API_CREATE_NEW_USER_ROLE_GROUP);
};

export const getRoles = async (): Promise<ApiResponse<Array<ApiRoleResponse>>> => {
	return (await api()).get(API_NEW_USER_ROLES);
};

export const getNewGroupRoles = async (): Promise<ApiResponse<Array<ApiRoleResponse>>> => {
	return (await api()).get(API_NEW_GROUP_ROLES);
};

export const getExportUserList = async (payload: ExportUserListPayload): Promise<ApiResponse<ExportUserListResponse>> => {
	return (await api()).post(API_GET_USER_REPORT, payload);
};
